import ModalConfirmClose from 'Features/CreateTemplatesForm/Components/ModalConfirmClose';
import { useRef, useState } from 'react';
import useThemeStore from 'Theme/store';

const ToolForm = ({
  Icon,
  title,
  desc,
  to,
  group,
  fromColor,
  api,
  showConfirm = false,
}) => {
  const { theme: themeValue } = useThemeStore();
  const [cancelTrialOpen, setCancelTrialOpen] = useState(false);
  const formRef = useRef(null);

  const handleClose = () => {
    setCancelTrialOpen(false);
    submitForm();
  };

  const handleSubmit = () => {
    if (showConfirm) {
      setCancelTrialOpen(true);
    } else {
      submitForm();
    }
  };

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  return (
    <>
      <form
        ref={formRef}
        action={to}
        method="POST"
        className="flex relative font-figtree"
      >
        <input
          type="hidden"
          name="token"
          value={api.defaults.headers.common['x-access-token']}
        />
        <button
          type="button"
          onClick={handleSubmit}
          className="flex-1 text-left"
        >
          <div
            className={`flex-1 ${
              themeValue === 'dark' ? 'bg-night-black' : 'bg-white'
            } rounded-md transition hover:shadow-md overflow-hidden md:max-w-1lg cursor-pointer md:flex relative transform hover:scale-105  mr-4`}
          >
            {Icon && (
              <div
                className={`md:flex-shrink-0 flex justify-start items-center ml-8 text-${
                  fromColor ? fromColor : 'green-500'
                }`}
              >
                <Icon className="h-16 w-16 mb-4 mt-4" />
              </div>
            )}
            <div className="p-4">
              <div
                className={`uppercase tracking-wide text-sm text-${
                  fromColor ? fromColor : 'green-500'
                } font-semibold leading-none`}
              >
                {group || ''}
              </div>
              <div
                className={`block text-lg xl:text-xl 2xl:text-2xl leading-tight font-base text-battleship-gray dark:text-quicksilver`}
              >
                {title}
              </div>
              <p className="mt-1 pr-1 text-base text-cool-gray dark:text-crystal-bell">
                {desc}{' '}
              </p>
            </div>
          </div>
        </button>
      </form>
      <ModalConfirmClose
        open={cancelTrialOpen}
        onCancel={() => setCancelTrialOpen(false)}
        onClose={handleClose}
        title="Are you sure?"
        description="Be aware that by cancelling your trial, you will forfeit any unused coins and will automatically return to the free tier service."
        confirmButtonText="Accept"
        cancelButtonText="Cancel"
      />
    </>
  );
};

export default ToolForm;
